import React from "react";
import { createRoot } from "react-dom/client";

import App from "./App.jsx";
import "./style.css";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      error: null,
    };
  }

  static getDerivedStateFromError(error) {
    return {
      error,
    };
  }

  componentDidCatch(error, errorInfo) {
    console.error(
      "OjMee Orbit render error:",
      error,
      errorInfo,
    );
  }

  render() {
    if (this.state.error) {
      return (
        <main
          style={{
            minHeight: "100vh",
            display: "grid",
            placeItems: "center",
            padding: "24px",
            background: "#061a32",
            color: "#ffffff",
            fontFamily: "Arial, sans-serif",
          }}
        >
          <section
            style={{
              width: "min(650px, 100%)",
              padding: "32px",
              border: "1px solid #174d78",
              borderRadius: "20px",
              background: "#0a2748",
            }}
          >
            <h1 style={{ color: "#00a3ff" }}>
              OjMee Orbit
            </h1>

            <h2>Application render error</h2>

            <pre
              style={{
                padding: "16px",
                overflow: "auto",
                borderRadius: "10px",
                background: "#041426",
                color: "#ffadb3",
                whiteSpace: "pre-wrap",
              }}
            >
              {this.state.error?.stack ||
                this.state.error?.message ||
                String(this.state.error)}
            </pre>
          </section>
        </main>
      );
    }

    return this.props.children;
  }
}

const rootElement =
  document.getElementById("root");

if (!rootElement) {
  throw new Error(
    'Root element "#root" was not found',
  );
}

createRoot(rootElement).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);